enum BaseRoutes {
    SIGN_IN = "signIn",
    SETTINGS = "settings",
    APPS = "apps",
    APP_SIGN_IN = "appSignIn",
    CODE_CHECK = "checkCode",
}

export default BaseRoutes;
